<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Production
      </p>
      <ul class="menu-list">
        <li>
          <a class="">General</a>
          <ul>
            <li @click="activeMenuLink = 'production/open-orders-2'"><router-link to="/production/open-orders-2"  :class="{'is-active':activeMenuLink === 'production/open-orders-2'}">All Open Orders</router-link></li>
            <li v-if="task_allowed('open_orders_pat')" @click="activeMenuLink = 'production/open-orders-pat'" ><router-link to="/production/open-orders-pat"  :class="{'is-active':activeMenuLink === 'production/open-orders-pat'}">Open Orders For Pat</router-link></li>
            
          </ul>
        </li>

        <li >
          <a class="">Orders</a>
          <ul>
            <li @click="activeMenuLink = '/production/incoming-orders'"><router-link to="/production/incoming-orders"  :class="{'is-active':activeMenuLink === '/production/incoming-orders'}">Incoming Orders</router-link></li>
             <li @click="activeMenuLink = '/production/export-scheduler'"><router-link to="/production/export-scheduler"  :class="{'is-active':activeMenuLink === '/production/export-scheduler'}">Export to Scheduler</router-link></li>
             <li @click="activeMenuLink = '/production/export-planner'"><router-link to="/production/export-planner"  :class="{'is-active':activeMenuLink === '/production/export-planner'}">Export to Planner</router-link></li>
             
          </ul>
        </li>

        <li >
          <a class="">Admin</a>
          <ul>
            <li v-if="task_allowed('garment_admin')" @click="activeMenuLink = '/production/garment-admin'"><router-link to="/production/garment-admin"  :class="{'is-active':activeMenuLink === '/production/garment-admin'}">Garment Admin</router-link></li>
            <li v-if="task_allowed('trexcode_admin')" @click="activeMenuLink = '/production/trexcode-admin'"><router-link to="/production/trexcode-admin"  :class="{'is-active':activeMenuLink === '/production/trexcode-admin'}">Trex Code Admin</router-link></li>
            <li @click="activeMenuLink = '/production/hist-lw-orders'"><router-link to="/production/hist-lw-orders"  :class="{'is-active':activeMenuLink === '/production/hist-lw-orders'}">Hist LW Orders</router-link></li>
          </ul>
        </li>
        
        
        
      </ul>
      
    </aside>
    
   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  name: 'SideBarOffshore',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { 
      activeMenuLink: null,
      user: {tasks: []},
     }
  },
  mounted() {
    //this.activeMenuLink = this.$route.path.substring(1)
    this.activeMenuLink = this.$route.path
    console.log(this.activeMenuLink)
  },
  created() {
		this.getAccessToken()
        .then(() => { 
           this.getUserProfile(1); // 1 for with_tasks
        });
	}
}

</script>



